<template>
  <div class="renwu">
    <!-- 分组维护 -->
    <div class="top">
      <Input
        v-model="groupNameLike"
        @on-clear="selectStatementRecordList(1)"
        @on-enter="selectStatementRecordList(1)"
        placeholder="请输入分组名称进行搜索"
        clearable
        class="journal-input"
      >
        <Icon type="ios-search" slot="prefix" />
      </Input>
      <Button class="btn fourSize" type="success" @click="addItem" ghost
        >新增</Button
      >
    </div>
    <div class="table-cont">
      <Table
        @on-sort-change="changesort"
        stripe
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        :total="obj.count"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>

    <!-- 新增 修改弹框 -->
    <Modal
      class="ivumodal"
      footer-hide
      width="500"
      v-model="modify"
      :title="title"
    >
      <div class="modal-cont">
        <Form
          ref="xiugai"
          :model="xiugai"
          :rules="xiugaidata"
          :label-width="150"
        >
          <FormItem label="分组名称：" prop="groupName" class="bumenModal-item">
            <Input v-model="xiugai.groupName" placeholder="请输入分组名称" />
          </FormItem>
          <FormItem label="分组排序：" prop="showOrder" class="bumenModal-item">
            <Input
              type="number"
              v-model="xiugai.showOrder"
              placeholder="请输入分组排序（范围0-1000）"
            />
          </FormItem>
        </Form>
        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="clear(1)"
            >取消</Button
          >
          <Button
            class="btn sure"
            type="success"
            ghost
            @click="clear(2, 'xiugai')"
            >确定</Button
          >
        </div>
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        questionGroup,
        postquestionGroup,
        updateQuestionGroup
    } from "../servers/api";
    export default {
        name: "jiesuan",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                selectNum: 0,
                selectList: [],
                xiugai: {
                    groupName: "",
                    showOrder: ""
                },
                modify: false,
                xiugaidata: {
                    showOrder: [{
                        required: true,
                        message: "请输入分组排序",
                        trigger: "blur",
                        Number
                    }],
                    groupName: [{
                        required: true,
                        message: "请输入分组名称",
                        trigger: "blur"
                    }]
                },
                data: [],
                columns: [{
                    type: "selection",
                    width: 50,
                    align: "center"
                }, {
                    title: "分组名称",
                    align: "center",
                    key: "groupName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "分组排序",
                    width: 250,
                    align: "center",
                    key: "showOrder",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "操作",
                    key: "awssd",
                    align: "center",
                    width: 90,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "div", {
                                    style: {
                                        width: "50px",
                                        height: "27px",
                                        "line-height": "27px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        background: "#fff",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        "margin-left": "2px",
                                        cursor: "pointer",
                                        display: "inline-block",
                                        color: "#7F7F7F"
                                    },
                                    on: {
                                        click: () => {
                                            this.chengeTable(params.row);
                                        }
                                    }
                                },
                                "修改"
                            )
                        ]);
                    }
                }],
                current: 1,
                pageSize: 20,
                obj: {},
                orderField: "",
                isAsc: "",
                title: "新增",
                groupNameLike: ""
            };
        },
        created() {
            this.selectStatementRecordList();
            this.actionUrl = sessionStorage.getItem("baseUrlWTS") + "/wts/oos/uploadimage";
        },
        methods: {
            clear(index, name) {
                //确定
                if (index == 2) {
                    //确定
                    this.$refs[name].validate(valid => {
                        if (valid) {
                            if (this.xiugai.groupId && this.xiugai.groupId !== "") {
                                this.postupdateNaire();
                            } else {
                                this.postquestionGroup();
                            }
                        }
                    });
                } else {
                    this.modify = false;
                }
            },
            postupdateNaire() {
                //修改
                updateQuestionGroup(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        this.modify = false;
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList();
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            selectStatementRecordList(index) {
                //获取列表
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    groupNameLike: this.groupNameLike,
                    page: this.current,
                    limit: this.pageSize,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                questionGroup(params).then(res => {
                    if (res.data.code == 10000) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data || {};
                        this.data = res.data.data.groupList || [];
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                        this.obj = {};
                        this.data = [];
                    }
                });
            },
            postquestionGroup() {
                //添加新增接口
                this.isiconfontshow = true;
                postquestionGroup(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        this.modify = false;
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList();
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            postbackNaires() {
                //新建
                this.isiconfontshow = true;
                postbackNaire(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        this.modify = false;
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList(1);
                    }
                });
            },
            chengeTable(item) {
                //修改
                item.showOrder = item.showOrder + "";
                this.title = "修改";
                let obj = JSON.parse(JSON.stringify(item));
                this.xiugai = obj;
                this.modify = true;
            },
            addItem() {
                //新增
                this.title = "新增";
                this.modify = true;
                this.xiugai = {
                    groupName: "",
                    showOrder: ""
                };
                this.$refs["xiugai"].resetFields();
            },
            changepeoplepage(num) {
                //换每页请求多少条
                this.pageSize = num;
                this.selectStatementRecordList(1);
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectStatementRecordList();
            },
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectStatementRecordList(1);
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .bumenModal-item {
        margin-top: 15px;
        vertical-align: middle;
    }

    .modal-cont {
        width: 100%;
        max-height: 500px;
        overflow: hidden;
        overflow-y: visible;
        padding-bottom: 20px;
        padding-right: 20px;
    }

    .modal-img-cont {
        width: 100%;
        position: relative;
        border: 1px solid #53cac3;
        height: 120px;
        border-radius: 5px;
        margin-top: 10px;
    }

    .position {
        position: absolute;
        top: 5px;
        font-size: 25px;
        color: #53cac3;
        right: 5px;
        cursor: pointer;
    }

    .modal-img-cont-title {
        display: inline-block;
        height: 100%;
        width: 150px;
        line-height: 90px;
        vertical-align: top;
    }

    .modal-img-cont-img {
        display: inline-block;
        width: 150px;
        height: 105px;
        margin: 5px 15px;
    }

    .modal-num {
        width: 100%;
        text-align: right;
        color: #53cac3;
        line-height: 10px;
    }

    .modal-span {
        width: 178px;
        display: inline-block;
        line-height: 17px;
        vertical-align: middle;
    }

    .i-icon {
        font-size: 25px;
        font-weight: 700;
        line-height: 30px;
        vertical-align: middle;
        color: #53cac3;
        margin-left: 3px;
        cursor: pointer;
        display: inline-block;
    }

    .renwu {
        font-size: 13px;
        padding: 15px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .btn {
            float: right;
        }
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .select {
            width: 100px;
            // margin-right: 15px;
        }
        .journal-input {
            width: 180px;
            vertical-align: top;
        }
        .data {
            width: 190px;
            vertical-align: top;
        }
        .table-cont {
            padding-top: 40px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
        .title-btn {
            vertical-align: top;
            float: right;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/questions/Fenzu.vue